var nameMixin = {
  methods: {
    getPatientName(user) {
      var name = ''
      var patient = user.patient
      if (patient !== null) {
        if (Object.prototype.hasOwnProperty.call(patient, 'full_name')) {
          if (patient.full_name && patient.full_name !== null) {
            name = patient.full_name
          }
          else {
            if (patient.first_name || patient.last_name) {
              name = `${patient.first_name} ${patient.last_name}`
            }
            else {
              name = user.email
            }
          }
        }
        else {
          name = user.email
        }
      }
      else {
        name = user.email
      }
      return name;
    },
    getDoctorName() {
      //
    }
    
  }
};

export default nameMixin